import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import useAdminData from "../hooks/useAdminData";

//  Styles
import "./MessageBox.scss";

/**
 * 
 * @ To Fix
 * On deleting a message, re-renders the deleted one before refresh (getAllMessages)
 */

const MessageBox = ({ message, index }) => {
    const { readMessage, getMessage, deleteMessage, error } = useAdminData();

    const [msg, setMsg] = useState(message);

    return msg !== null && (
        <Card
            style={{ maxWidth: "20rem", borderWidth: "2px" }}
            className={`m-3 ${msg.read ? "message-read shadow-sm" : "shadow"} `}
            border={msg.read ? "success" : "danger"}
        >
            <Card.Header>
                {msg.read ? <i className="fas fa-check-double"> </i> : null} De:{" "}
                {msg.name}{" "}
            </Card.Header>
            <Card.Body>
                <Card.Title>Subject: {msg.subject}</Card.Title>
                <Card.Subtitle className="mb-2 text-muted">
                    {msg.email}
                </Card.Subtitle>
                <Card.Text>{msg.text}</Card.Text>
            </Card.Body>
            <Card.Footer>
                <div className="buttons">
                    <Button
                      
                        size="sm"
                        href={`mailto:${msg.email}`}
                        onClick={() => {
                            readMessage(msg._id, msg.read, index).then(() => {
                                getMessage(msg._id).then(res => {
                                    setMsg(res);
                                });
                            });
                        }}
                    >
                        Answer
                    </Button>
                    <Button
                        variant="danger"
                        size="sm"
                        onClick={() => {
                            deleteMessage(msg._id).then(() => {
                                setMsg(null);
                            });
                        }}
                    >
                        Delete
                    </Button>
                </div>
                {error && `⚠️ ${error}`}
            </Card.Footer>
        </Card>
    );
};
export default MessageBox;
